<div class="grid pt-2 ml-2">
    @if (showImage) {
        <div class="flex flex-row align-items-center responsive-screen ml-1">
            @if(imgFileUrl) {
                <app-mi-image-container [miImage]="imgFileUrl" miWidth="53" class="overview-image"></app-mi-image-container>
            }
            @else {
                <app-mi-image-container class="status-img" [miImage]="defaultLoaderImg" miWidth="53"></app-mi-image-container>
            }
        </div>
    }
    <div class="col-12 pl-2">
        <div class="initial-details mb-1">
            <label class="record-name">{{ entityForStatus?.entityName ? entityForStatus?.entityName : '--' }}</label>
            @if(entityForStatus?.entityStatus) {
                <label class="status">
                    @for (item of entityForStatus?.entityStatus | keyvalue; track item.key) {
                        @if (item.value === 'Draft' || item.value === 'Active' || item.value === 'Inactive' || item.value === 'Completed' || item.value === 'Running' || item.value === 'Paused' || item.value === 'Stopped') {
                            <span>
                                <label class="detail-value border-round-md status-box" [ngClass]="{
                                    'active': item.value?.toLowerCase() === 'active',
                                    'inactive': item.value?.toLowerCase() === 'inactive',
                                    'draft': item.value?.toLowerCase() === 'draft',
                                    'completed': item.value?.toLowerCase() === 'completed',
                                    'running': item.value?.toLowerCase() === 'running',
                                    'paused': item.value?.toLowerCase() === 'paused',
                                    'stopped': item.value?.toLowerCase() === 'stopped'
                                }">{{ item.value }}</label>
                            </span>
                        }@else {
                            <span class="detail-value ml-2">{{item.key}}: </span><span class="value mr-2">{{item.value}}</span>
                      
                        }
                    }
                    
                    
                </label>
            }

        </div>

        <div class="other-details">
            @for (item of entityForStatus?.otherFields | keyvalue; track item.key; let i = $index) {
                <span class="detail-value">{{item.key}}: </span><span class="value mr-2">{{item.value}}</span>
                @if (i < (entityForStatus?.otherFields | keyvalue).length - 1) {
                    <span class="separator">|</span>
                }
            }
        </div>
        
            <div class="other-details">
                @if (dataForVehicleStatus) {
                        @for (vehicleData of dataForVehicleStatus; track vehicleData; let i = $index) {
                            @if(vehicleData.vehicleType === 'type' || vehicleData.userId){
                                @if(vehicleData?.vehicleType === 'type'){
                                    <label class="value mr-2"> {{ vehicleData.text }}</label> 
                                  
                                    @if (i < dataForVehicleStatus.length - 1) {
                                        <label class="separator">|</label>
                                    }
                                }@else{
                                    <div class="user-info align-items-center" >
                                        <i [class]="vehicleData.icon"></i> <label class="user-name mr-2">{{ vehicleData.text }}</label>
                                    </div>
                                }
                            } @else {
                                @if (vehicleData.label) {
                                    <label class="name">{{ vehicleData.label }} :</label>
                                }
                                <label class="value ml-1"> {{ vehicleData.text }}</label>
                                @if (i < dataForVehicleStatus.length - 1 && dataForVehicleStatus[i + 1].label !== '') {
                                    
                                    @if (i == 1){
                                        <label class="separator">|</label>
                                        <br />
                                    }
                                    
                                    @else {
                                        <label class="separator">|</label>
                                    }
                                }
            
                            }
            
                        }
                }
            </div>
        <!-- } -->
    </div>
</div>
